<mat-accordion multi="true">
  <mat-expansion-panel class="exp-panel" [expanded]="expanded" hideToggle>
    <mat-expansion-panel-header (click)="handleExpansion()" class="exp-panel-header bg-secondary">
      <mat-panel-title class="exp-panel-title text-primary"> Live TV </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="tv-container">
      @if (tvChannels.length > 0 && isEventMarkets) {
        <mat-tab-group>
          @for (channel of tvChannels; track channel; let i = $index) {
            <mat-tab [label]="'Channel ' + channel?.Channel">
              <div class="frame-container">
                <mat-icon class="full-screen-icon" (click)="handleDialog(channel.url)">fullscreen</mat-icon>
                <iframe class="tv-frame" [src]="channel.url | safeUrl" width="100%" allowfullscreen> </iframe>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
